
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import GetAppIcon from '@material-ui/icons/GetApp';
import Tooltip from '@material-ui/core/Tooltip';

const styles = theme => ({
    margin: {
        margin: theme.spacing.unit,
    },
});

class CreateCsvFile extends Component {
    constructor(props) {
        super(props);
        this.createCsvFile = this.createCsvFile.bind(this);
    }

    createCsvFile() {
        var fileName = "HunterGame-Projects.csv";//匯出的檔名
        var data = getData(this.props.data);

        var link = document.createElement("a");
        link.href = "data:application/csv;charset=utf-8,%EF%BB%BF" + encodeURIComponent(data);
        link.download = fileName;
        link.click();
    }

    render() {
        const { classes } = this.props;

        return (
            <div>
                <IconButton aria-label="Delete" className={classes.margin} onClick={event => this.createCsvFile()}>
                    <Tooltip title="Download CSV">
                        <GetAppIcon fontSize="small" />
                    </Tooltip>
                </IconButton>
            </div>
        )
    }
}

function getData(data) {
    const rows = [
        'Project ID',
        'Project Name',
        // 'Deal Name',
        'Client',
        'Sales ID',
        'Sales',
        'Project Team ID',
        'Project Team',
        'Tag',
        'Project Create Time',
        'Completed Perent',
        'ManDayAchievingRate'
    ];

    var header = '';
    for (var i = 0; i < rows.length; i++) {
        if (i < rows.length - 1) {
            header += rows[i] + ',';
        }
        else {
            header += rows[i] + '\n';
        }
    }

    var body = "";
    for (i = 0; i < data.length; i++) {
        var str = "";
        str += data[i].id + ","
        str += data[i].ProjectName + ","
        // str += data[i].DealTitle + ","
        str += data[i].CompanyName + ","
        str += data[i].SalesId + ","
        str += data[i].SalesName + ","
        str += data[i].DepartmentId + ","
        str += data[i].DepartmentName + ","
        str += data[i].Tag.map(item => {
            return item.value
        }) + ","
        str += data[i].ProjectCreateTime + ","
        str += data[i].CompletedPerent + ","
        str += data[i].ManDayAchievingRate + ","

        body = body + str + "\n";
    }

    return header + body;
}

CreateCsvFile.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CreateCsvFile);



// WEBPACK FOOTER //
// ./src/components/Projects/CreateCsvFile.js